(function() {
  "use strict";
  var W = [ 500, 800, 1100, 1400 ];
  var reduce = window.matchMedia ? window.matchMedia("(prefers-reduced-motion: reduce)") : null;
  function sized(u, w) {
    return String(u).replace(/([?&])width=\d+/, "$1width=" + w);
  }
  function pathOf(u) {
    return String(u || "").split("?")[0].replace(/^https?:/, "");
  }
  function relabel(scope) {
    var b = scope.querySelectorAll("[data-offer-badge]");
    for (var i = 0; i < b.length; i++) {
      var t = b[i].textContent;
      if (t.charAt(0) === "-") b[i].textContent = "Spar " + t.slice(1).replace("%", " %");
    }
  }
  function init(root) {
    if (!root || root.__fsPdp) return;
    root.__fsPdp = true;
    var main = root.querySelector("[data-fs-main]");
    var hero = main ? main.querySelector("img") : null;
    var strip = root.querySelector("[data-fs-thumbs]");
    var thumbs = strip ? Array.prototype.slice.call(strip.querySelectorAll("[data-fs-src]")) : [];
    var cur = 0;
    thumbs.forEach(function(t, i) {
      if (t.getAttribute("aria-pressed") === "true") cur = i;
    });
    function mark(i, instant) {
      var t = thumbs[i];
      if (!t) return;
      var left = strip ? Math.max(0, t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2) : 0;
      cur = i;
      for (var k = 0; k < thumbs.length; k++) thumbs[k].setAttribute("aria-pressed", k === i ? "true" : "false");
      if (!strip || Math.abs(strip.scrollLeft - left) < 2) return;
      var smooth = !instant && !(reduce && reduce.matches);
      if (strip.scrollTo) strip.scrollTo({
        left: left,
        behavior: smooth ? "smooth" : "auto"
      }); else strip.scrollLeft = left;
    }
    function show(i) {
      var t = thumbs[i];
      if (!t || !hero) return;
      var src = t.getAttribute("data-fs-src");
      hero.srcset = W.map(function(w) {
        return sized(src, w) + " " + w + "w";
      }).join(", ");
      hero.src = src;
      hero.alt = t.getAttribute("data-fs-alt") || "";
      mark(i, false);
    }
    function step(d) {
      if (thumbs.length > 1) show((cur + d + thumbs.length) % thumbs.length);
    }
    root.addEventListener("click", function(e) {
      var b = e.target.closest("[data-fs-prev],[data-fs-next],[data-fs-src]");
      if (!b || !root.contains(b)) return;
      if (b.hasAttribute("data-fs-src")) show(thumbs.indexOf(b)); else step(b.hasAttribute("data-fs-next") ? 1 : -1);
    });
    if (main && thumbs.length > 1) {
      var x0 = null, y0 = 0;
      main.addEventListener("pointerdown", function(e) {
        if (!e.isPrimary || window.visualViewport && window.visualViewport.scale > 1.01) {
          x0 = null;
          return;
        }
        x0 = e.button || e.target.closest("button") ? null : e.clientX;
        y0 = e.clientY;
      }, {
        passive: true
      });
      main.addEventListener("pointerup", function(e) {
        if (x0 === null) return;
        var dx = e.clientX - x0, dy = e.clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) step(dx < 0 ? 1 : -1);
      }, {
        passive: true
      });
      main.addEventListener("pointercancel", function() {
        x0 = null;
      }, {
        passive: true
      });
    }
    if (hero && thumbs.length && window.MutationObserver) {
      new MutationObserver(function() {
        var p = pathOf(hero.getAttribute("src"));
        for (var i = 0; i < thumbs.length; i++) {
          if (pathOf(thumbs[i].getAttribute("data-fs-src")) === p) {
            if (i !== cur || thumbs[i].getAttribute("aria-pressed") !== "true") mark(i, false);
            return;
          }
        }
      }).observe(hero, {
        attributes: true,
        attributeFilter: [ "src" ]
      });
    }
    var offers = root.querySelector("[data-offers]");
    if (offers) {
      relabel(offers);
      if (window.MutationObserver) {
        new MutationObserver(function() {
          relabel(offers);
        }).observe(offers, {
          childList: true,
          characterData: true,
          subtree: true
        });
      }
    }
    if (cur > 0) mark(cur, true);
  }
  function initAll(scope) {
    var n = (scope || document).querySelectorAll("[data-fs-pdp]");
    for (var i = 0; i < n.length; i++) init(n[i]);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function() {
    initAll();
  }); else initAll();
  document.addEventListener("shopify:section:load", function(e) {
    initAll(e.target);
  });
})();
